import React from "react";

function PrivacyPolicy() {
  return (
    <div
      style={{
        maxWidth: 900,
        margin: "40px auto",
        padding: "20px",
        fontFamily: "Arial, sans-serif",
        color: "#2c3e50",
        lineHeight: 1.6,
      }}
    >
      <h1>Privacy Policy</h1>

      <p>
        <strong>Effective Date:</strong> August 30, 2026
      </p>

      <p>
        MukBi ("MukBi", "we", "us", or "our") provides business customer
        relationship management and communication tools that help businesses
        manage customers, leads, conversations, and related business
        information.
      </p>

      <p>
        This Privacy Policy explains how Mukbi collects, uses, stores, and
        protects information when you use our application and services.
      </p>

      <h2>1. Information We Collect</h2>

      <p>
        Depending on how you use Mukbi, we may collect and process the
        following information:
      </p>

      <ul>
        <li>
          Account information such as your name, email address, and login
          information.
        </li>
        <li>
          Business and customer information entered into or managed through
          MUkBi.
        </li>
        <li>
          Customer contact information, including phone numbers and names,
          where provided by the business using MUkBi.
        </li>
        <li>
          WhatsApp Business account and business profile information required
          to provide WhatsApp-related functionality.
        </li>
        <li>
          WhatsApp messages and conversation information processed through
          the WhatsApp Business Platform integration.
        </li>
        <li>
          Technical information necessary to operate, secure, and improve the
          service.
        </li>
      </ul>

      <h2>2. How We Use Information</h2>

      <p>
        We use information collected through MukBi to:
      </p>

      <ul>
        <li>Provide and operate the Mukbi CRM and communication services.</li>
        <li>Manage customers, leads, and business conversations.</li>
        <li>
          Enable businesses to connect and use their WhatsApp Business
          accounts.
        </li>
        <li>
          Send and receive WhatsApp messages on behalf of businesses when
          authorized by them.
        </li>
        <li>Maintain conversation and customer records.</li>
        <li>Provide customer support.</li>
        <li>Maintain security and prevent unauthorized access or misuse.</li>
        <li>Improve the reliability and functionality of Mukbi.</li>
      </ul>

      <h2>3. WhatsApp and Meta Information</h2>

      <p>
        Mukbi may integrate with Meta's WhatsApp Business Platform and related
        Meta business services.
      </p>

      <p>
        When a business connects its WhatsApp Business account to Mukbi, we
        may process information made available through the authorized Meta
        integration, including WhatsApp Business account information, phone
        number information, business profile information, message information,
        and related account or messaging events.
      </p>

      <p>
        Mukbi uses this information only to provide the functionality
        authorized by the business and to operate the Mukbi service.
      </p>

      <h2>4. Information Sharing</h2>

      <p>
        We do not sell personal information.
      </p>

      <p>
        Information may be shared with service providers and technology
        providers that help us operate, secure, host, maintain, or improve
        Mukbi. Such providers receive only the information reasonably
        necessary to provide their services.
      </p>

      <p>
        Information may also be disclosed where required by applicable law,
        regulation, legal process, or to protect the rights, security, and
        integrity of Mukbi and its users.
      </p>

      <h2>5. Data Security</h2>

      <p>
        We use reasonable technical and organizational measures designed to
        protect information against unauthorized access, alteration,
        disclosure, or destruction.
      </p>

      <p>
        No method of electronic transmission or storage can be guaranteed to
        be completely secure, and therefore we cannot guarantee absolute
        security.
      </p>

      <h2>6. Data Retention</h2>

      <p>
        We retain information for as long as reasonably necessary to provide
        the Mukbi services, maintain business records, comply with legal
        obligations, resolve disputes, and enforce our agreements.
      </p>

      <p>
        Businesses may request deletion of information associated with their
        Mukbi account, subject to applicable legal, security, and operational
        requirements.
      </p>

      <h2>7. WhatsApp Data</h2>

      <p>
        WhatsApp messages and related information processed through Mukbi are
        handled for the purpose of providing the business communication and
        CRM functionality requested by the business.
      </p>

      <p>
        Mukbi does not use WhatsApp customer message content for unrelated
        advertising purposes.
      </p>

      <h2>8. User Rights and Requests</h2>

      <p>
        Depending on applicable law, individuals may have rights regarding
        their personal information, including rights to access, correct, or
        request deletion of information.
      </p>

      <p>
        Requests relating to information handled by a business through Mukbi
        may also need to be directed to that business, as the business may be
        the party responsible for the relevant customer information.
      </p>

      <h2>9. Third-Party Services</h2>

      <p>
        Mukbi may rely on third-party services, including infrastructure,
        hosting, authentication, analytics, and Meta's WhatsApp Business
        Platform, to provide its functionality.
      </p>

      <p>
        These services may process information in accordance with their own
        terms and privacy policies.
      </p>

      <h2>10. Children's Privacy</h2>

      <p>
        Mukbi is intended for business use and is not directed toward
        children.
      </p>

      <h2>11. Changes to This Privacy Policy</h2>

      <p>
        We may update this Privacy Policy from time to time to reflect changes
        to our services, technology, legal requirements, or business
        practices. Updated versions will be made available through this page.
      </p>

      <h2>12. Contact Us</h2>

      <p>
        If you have questions about this Privacy Policy or how Mukbi handles
        information, please contact us at:
      </p>

      <p>
        <strong>Mukbi</strong>
        <br />
        Support: +91 - 97787 97784
      </p>

      <hr style={{ margin: "40px 0", border: "0", borderTop: "1px solid #ddd" }} />

      <p style={{ fontSize: 13, color: "#777" }}>
        Last updated: August 30, 2026
      </p>
    </div>
  );
}

export default PrivacyPolicy;